export type ImageKey = keyof typeof imageMap;

// We need to import the image this way because otherwise the static assets are loaded from the host URL
// instead of the remote URL. So e.g. MFE runs on localhost:5174 and remote runs on localhost:3001 then
// images would be loaded from localhost:5174 instead of from localhost:3001
const FAMILY_IMAGE = new URL('../../styles/assets/images/family.jpg', import.meta.url).href;
const FAMILY_OUTPUT_IMAGE = new URL('../../styles/assets/images/family-output.jpg', import.meta.url).href;
const PASSION_IMAGE = new URL('../../styles/assets/images/passion.jpg', import.meta.url).href;
const PASSION_OUTPUT_IMAGE = new URL('../../styles/assets/images/passion-output.jpg', import.meta.url).href;
const SUCCESSION_IMAGE = new URL('../../styles/assets/images/succession.jpg', import.meta.url).href;
const SUCCESSION_OUTPUT_IMAGE = new URL('../../styles/assets/images/succession-output.jpg', import.meta.url).href;
const RETIREMENT_IMAGE = new URL('../../styles/assets/images/retirement.jpg', import.meta.url).href;
const RETIREMENT_OUTPUT_IMAGE = new URL('../../styles/assets/images/retirement-output.jpg', import.meta.url).href;
const REAL_ESTATE_IMAGE = new URL('../../styles/assets/images/realEstate.jpg', import.meta.url).href;
const REAL_ESTATE_OUTPUT_IMAGE = new URL('../../styles/assets/images/real-estate-output.jpg', import.meta.url).href;
const WEALTH_IMAGE = new URL('../../styles/assets/images/wealth.jpg', import.meta.url).href;
const WEALTH_OUTPUT_IMAGE = new URL('../../styles/assets/images/wealth-output.jpg', import.meta.url).href;
const MATURITY_IMAGE = new URL('../../styles/assets/images/wealth.jpg', import.meta.url).href;
const BUSINESS_IMAGE = new URL('../../styles/assets/images/business.jpg', import.meta.url).href;
const BUSINESS_OUTPUT_IMAGE = new URL('../../styles/assets/images/business-output.jpg', import.meta.url).href;
const ROADMAP_IMAGE = new URL('../../styles/assets/images/roadmap.png', import.meta.url).href;
const PENSION_IMAGE = new URL('../../styles/assets/images/pension.png', import.meta.url).href;
const SAVINGS_IMAGE = new URL('../../styles/assets/images/savings.png', import.meta.url).href;
const TAXES_IMAGE = new URL('../../styles/assets/images/taxes.png', import.meta.url).href;

export const imageMap = {
    FAMILY: FAMILY_IMAGE,
    PASSION: PASSION_IMAGE,
    SUCCESSION: SUCCESSION_IMAGE,
    RETIREMENT: RETIREMENT_IMAGE,
    REAL_ESTATE: REAL_ESTATE_IMAGE,
    WEALTH: WEALTH_IMAGE,
    MATURITY: MATURITY_IMAGE,
    BUSINESS: BUSINESS_IMAGE,
    ROADMAP: ROADMAP_IMAGE,
    PENSION: PENSION_IMAGE,
    SAVINGS: SAVINGS_IMAGE,
    TAXES: TAXES_IMAGE,
};

const isKeyOfImageMap = (key: string): key is ImageKey => Object.prototype.hasOwnProperty.call(imageMap, key);

export const getImageUrlByString = (key?: string) => {
    if (key && isKeyOfImageMap(key)) return imageMap[key];
    else return '';
};

export const clientOutputEventsImageMap: Record<string, string> = {
    FAMILY: FAMILY_OUTPUT_IMAGE,
    PASSION: PASSION_OUTPUT_IMAGE,
    SUCCESSION: SUCCESSION_OUTPUT_IMAGE,
    RETIREMENT: RETIREMENT_OUTPUT_IMAGE,
    REAL_ESTATE: REAL_ESTATE_OUTPUT_IMAGE,
    WEALTH: WEALTH_OUTPUT_IMAGE,
    BUSINESS: BUSINESS_OUTPUT_IMAGE,
};
